<template>
		<section class="ftco-section">
		<div class="container">
            <div v-if="error">
                <app-message :matn="error_message" ></app-message>
            </div>
			<div class="row justify-content-center">
				<div class="col-md-7 col-lg-4">
					<div class="login-wrap p-4 p-md-5">
		      	<div class="icon d-flex align-items-center justify-content-center">
		      		<v-img src="./assets/delfin.png"></v-img>
		      	</div>
		      	<h3 class="text-center mb-4">Авторизация</h3>
                <div >
                <v-form @submit.prevent="login"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >

                    <v-text-field
                    v-model="form.login"
                    :counter="9"
                    :rules="nameRules"
                    label="Номер телефона"
                    required
                    autofocus
                    ></v-text-field>

                     <v-text-field
                    v-model="form.password"

                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="passwordRules"
                    label="Введие пароль"
                    required
                    clearable
                    ></v-text-field>



	            <div class="form-group mt-4" v-if="!loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                   type="submit"
                    >Войти</v-btn>

	            </div>

                <div class="form-group mt-4" v-if="loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                    ><loading-spin></loading-spin></v-btn>

	            </div>



                     </v-form>

                </div>

	            <div class="form-group d-md-flex">
	            	<div class="w-50">

								</div>
								<div class=" w-50 text-md-right">
                                    <router-link to="/forget">Забыли пароль?</router-link>
								</div>
	                </div>

	                </div>
				</div>
			</div>
		</div>
	</section>

</template>

<script>

import axios from 'axios'

  export default {
    data: () => ({

        loading: false,
        error: false,
        valid: false,
        show1: false,

        error_message: '',

        form:{
            login: '',
            password: '',
        },

      nameRules: [
        v => !!v || 'Введите номер телефона',
        v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
        v => (v && v.length == 9) || 'Неверный формат номера телефона',
      ],

    passwordRules: [
        v => !!v || 'Введите пароль',
        v => (v && v.length >= 3) || 'Пароль должен быть не менее 3 символов',
     //   v=> (v && /[a-z]/.test(v)) || 'Пароль должен содержать минимум одну маленькую букву',
      //  v=> (v && /[A-Z]/.test(v)) || 'Пароль должен содержать минимум одну большую букву',
        v=> (v && /[0-9]/.test(v)) || 'Пароль должен содержать минимум одну цифру',
      //  v=> (v && /[^a-zA-Z0-9]/.test(v)) || 'Пароль должен содержать минимум один специальный символ',
      ],

    }),

    methods: {

       login(){
    //     this.loading = true;

    //     axios({
    //         method: 'post',
    //         url: '/api/login',
    //         data: this.form
    //     })
    //     .then(function (response) {
    //         alert(response.data.message);
    //     })
    //     .catch(function (error) {
    //         console.log(error);
    //     });


        axios.post('/api/login', this.form, {
                headers: {
                    "Content-type": "application/json"
                }
            })

                .then(response => {
                    if(response.data.status){

                      //  this.error_message = response.data.nom;
                      // alert(response.data.message);
                       // $this.loading = false;
                        this.$session.start();
                        this.$session.set('id_user', response.data.id_user);
                        this.$session.set('dostup', response.data.dostup);
                        this.$session.set('nom', response.data.nom);
                        this.$session.set('dostup_nom', response.data.dostup_nom);
                        this.$session.set('login', response.data.login);
                        this.$session.set('parol', response.data.parol);
                        this.$session.set('boyad_ivaz', response.data.boyad_ivaz);
                        this.$session.set('hash', response.data.hash);

                        this.$store.commit('dostup', response.data.dostup);
                        this.$store.commit('login', response.data.login);
                        this.$store.commit('parol', response.data.parol);
                        this.$store.commit('id_user', response.data.id_user);
                        

                        if(response.data.dostup == 1  ){
                             this.$router.push({name: 'home'});
                        }else if(response.data.dostup == 2){
                            this.$router.push({name: 'tovari'});
                        }else{
                            alert("У вас нет доступа к системе");
                           // this.$router.push({name: 'kassa'});
                        }

                    }else{
                         this.loading  = false;
                        this.error = true;
                        this.error_message = "Ошибка авторизации";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading  = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });
      }

    },
  }

</script>

<style>

</style>
